import type { NodeInstance } from '@glueapp/graph-types';
import { FormTriggerLayout } from '@/GraphEditor/drawingLayer/nodeComposition/FormTriggerLayout';

interface Props {
    nodeInstance: NodeInstance;
}

export const FormTriggerNode: React.FC<Props> = ({ nodeInstance }) => {
    return <FormTriggerLayout nodeInstance={nodeInstance} />;
};
